import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ApiResponse, MdgpDbApiProxy } from './types';

export interface MdgpDbApiClientOptions {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
}

export class MdgpDbApiClient implements MdgpDbApiProxy {
  private readonly fetchApi: FetchApi;
  private readonly discoveryApi: DiscoveryApi;
  private cache: any = {};

  constructor(options: MdgpDbApiClientOptions) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  public async get<T>(endpoint: string): Promise<T | Response> {
    const targetUrl = `${await this.discoveryApi.getBaseUrl('proxy')}/${endpoint}`;

    if (targetUrl in this.cache && this.cache[targetUrl].expires >= new Date().getTime()) {
      return this.cache[targetUrl].data as T;
    }

    const result = await this.fetchApi.fetch(targetUrl);
    if (result.status === 200) {
      const responseBody: ApiResponse<T> = await result.json();
      this.cache[targetUrl] = {
        expires: new Date().getTime() + 60000, // 1 minute, in ms
        data: responseBody.data,
      };
      return responseBody.data;
    }

    if (targetUrl in this.cache) {
      return this.cache[targetUrl].data as T;
    }

    return result;
  }
}
